import { render, staticRenderFns } from "./RecurringRemarkView.vue?vue&type=template&id=21970f63"
import script from "./RecurringRemarkView.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21970f63')) {
      api.createRecord('21970f63', component.options)
    } else {
      api.reload('21970f63', component.options)
    }
    module.hot.accept("./RecurringRemarkView.vue?vue&type=template&id=21970f63", function () {
      api.rerender('21970f63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurringremarks/RecurringRemarkView.vue"
export default component.exports